import GoogleTagManager from '@redux-beacon/google-tag-manager';
import logger from '@redux-beacon/logger';
// @ts-expect-error ...
import {eventsMap as omnichannelChatWidgetTrackingEventsMap} from '@travel-frontend/omnichannel-chat-widget/tracking';
import {gtmSplitIOEventsMap} from '@travel-frontend/split-io';
import {
  searchFormTrackingEventsMap,
  defaultInteractionEventsMap,
  headerNewTrackingEventsMap,
} from '@travel-frontend/ui-components';
import {createMiddleware} from 'redux-beacon';

import {eventsMap} from '@/redux/middleware/googleTagManager/eventsMap';

const originalGtmTarget = GoogleTagManager();

// @ts-expect-error ...
const gtmTarget = (...args) => {
  // original target throws an error if dataLayer isn't loaded (yet),
  // we don't want that. Lets rather push events onto the stack
  // and assume that it will load eventually.
  // Worst case would be the tracking not working,
  // but that's better than the whole page crashing...
  // @ts-expect-error ...
  if (!window.dataLayer) {
    // @ts-expect-error ...
    window.dataLayer = [];
  }
  // @ts-expect-error ...
  return originalGtmTarget(...args);
};

const options = import.meta.env.MODE === 'production' ? {} : {logger};

const SCARCITY_LOAD = 'tracking/LOAD';
const SCARCITY_CLICK = 'tracking/CLICK';

const {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars --- ...
  'tracking/PAGE_LOAD': _brokenPageLoadEvent,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars --- ...
  'tracking/PAGE_VIEW': _brokenPageViewEvent,
  ...sharedEvents
} = defaultInteractionEventsMap;

export const middleware = createMiddleware(
  {
    ...searchFormTrackingEventsMap,
    ...gtmSplitIOEventsMap,
    ...eventsMap,
    ...headerNewTrackingEventsMap,
    ...omnichannelChatWidgetTrackingEventsMap,
    ...sharedEvents,
    [SCARCITY_LOAD]: defaultInteractionEventsMap[SCARCITY_LOAD],
    [SCARCITY_CLICK]: defaultInteractionEventsMap[SCARCITY_CLICK],
  },
  gtmTarget,
  options
);
